import Repository from './Repository'
import TokenService from '../helpers/token'
const bituUrlReport = `${Repository.defaults.bituUrlReport}/v1`

const resource = `${Repository.defaults.baseURL}/customer-support`
const resourceDefault = `${Repository.defaults.baseURL}`
const uploadImage =`${Repository.defaults.uploadImageUrl}`

export default {
    async getRequestAction() {
        const response = await Repository.get(`${resource}/request-action`, {
            headers: TokenService.getHeader(),
        })
        return response
    },

    async create(request) {
        const response = await Repository.post(`${resource}`, request, {
            headers: TokenService.getHeader(),
        })
        return response
    },

    async list(params) {
        const response = await Repository.get(`${resource}`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response
    },

    async delete(id) {
        const response = await Repository.delete(`${resource}/${id}`, {
            headers: TokenService.getHeader(),
        })
        return response
    },

    async updateStatus(id, body) {
        const response = await Repository.post(`${resource}/${id}`, body, {
            headers: TokenService.getHeader(),
        })
        return response
    },

    async updateRequest(id, body) {
        const response = await Repository.patch(`${resource}/${id}`, body, {
            headers: TokenService.getHeader(),
        })
        return response
    },

    async statusList() {
        const response = await Repository.get(`${resource}/request-result-action`, {
            headers: TokenService.getHeader(),
        })
        return response
    },


    async urgentList() {
        const response = await Repository.get(`${resource}/urgent-request`, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async getListSupportsV2(params) {
        const response = await Repository.get(`${resourceDefault}/fg/list`,{
            params,
            headers: TokenService.getHeader(),
          })
        return response
    },
    async fgApiSet(payload) {
        return await Repository.post(`${Repository.defaults.baseURL}/fg/set`, payload);
    },
    async getGroupTickets(){
        const response = await Repository.get(`${resourceDefault}/fg/list?attrs[]=id&attrs[]=name&attrs[]=status&obj=ticket_group&filters[$eq__systemTicket]=0&filters[$eq__status]=active`,{
            headers: TokenService.getHeader(),
          })
        return response
    },
    async uploadImage(body) {
        const response = await Repository.post(`${uploadImage}/image/s3`,body, {
            headers: TokenService.getHeader(),
        });
        return response;
    },
    async getListSupportsV3(params) {
        const response = await Repository.get(`${resourceDefault}/ticket`,{
            params,
            headers: TokenService.getHeader(),
          })
        return response
    },
    async getListBituChat(params) {
        const response = await Repository.get(`${bituUrlReport}/conversation-referral/list`,{
            params,
            headers: TokenService.getHeader(),
          })
        return response
    }


}
